export default "/_next/static/images/keith-mosley-4963ae14b7a8c504ed1f5b04496b4172.png";